// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6cc28767","977":"328a19ce"}[chunkId] + ".chunk.js";
};